import { render } from "./PromptPreview.vue?vue&type=template&id=507c183e&scoped=true&ts=true"
import script from "./PromptPreview.vue?vue&type=script&lang=ts"
export * from "./PromptPreview.vue?vue&type=script&lang=ts"

import "./PromptPreview.vue?vue&type=style&index=0&id=507c183e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507c183e"]])

export default __exports__